import './app.css'
import Dancer from './assets/images/dancer@2x.png'

document.getElementById('dancer').setAttribute('src', Dancer)
